import dayjs from 'dayjs';
import { TIME_FORMAT } from './const';

const addZero = (value: number): string => `${value < 10 ? '0' : ''}${value}`;

export interface GenerateTimeProps {
  hourStep?: number;
  minuteStep?: number;
}

export const generateTime: (config?: GenerateTimeProps) => string[] = (config = {}) => {
  const { hourStep = 1, minuteStep = 1 } = config;
  const initialHours = 24;
  const initialMinutes = 60;
  const timeList: string[] = [];

  Array(initialHours / hourStep)
    .fill('*')
    .forEach((_, hour) => {
      Array(Math.floor(initialMinutes / minuteStep))
        .fill('*')
        .forEach((_, minute) => {
          timeList.push(`${addZero(hour * hourStep)}:${addZero(minute * minuteStep)}`);
        });
    });

  return timeList;
};

export const separateTime = (time: string) => time.split(':').map(Number);
export const checkDisabled = (time: number, disabledTimes?: number[]) =>
  disabledTimes?.includes(time);
export const checkSelected = (time: string, value?: dayjs.Dayjs | null) =>
  time === dayjs(value).format(TIME_FORMAT);
